<template>
    <div id="app">
        <div class="wrapper">
            <div class="top-content">
                <h2>{{productName}}</h2>
            </div>
            <ServiceOptions :globalFlag="globalFlag" :infoList="optionsInfos" :orderSource="orderSource"></ServiceOptions>
            <div class="interval"></div>

            <template v-if="ifUser">
                <UserInfoAfter :infos="userInfos" :orderSource="orderSource"></UserInfoAfter>
                <div class="interval"></div>
            </template>

            <AfterInfo :infos="serviceAfterInfos"></AfterInfo>
            <div class="interval"></div>

            <FirstReturnVisit v-if="orderSource == 4" :orderId="orderId"></FirstReturnVisit>
            <div class="interval"></div>
        </div>
        <div class="u-bottom-btns" v-if="globalFlag == 1">
            <Button class="btn-item btn-help" @click="callPolice">报警</Button>
            <Button v-if="contactPatientsUsedFlag == 1" class="btn-item btn-success" @click="callPhone">联系患者</Button>
            <Button v-else class="btn-item btn-success" style="opacity: 0.7">联系患者</Button>
        </div>
        <div class="u-bottom-btns" v-else>
            <Button class="btn-item btn-success" style="opacity: 0.7">已结束</Button>
        </div>
    </div>
</template>

<script>
    import {Icon, Button} from 'vant'
    import ServiceOptions from '@/components/ServiceOptions/ServiceOptions.vue'
    import AfterInfo from '@/components/ServiceInfos/AfterInfo.vue'
    import UserInfoAfter from '@/components/UserInfoAfter/UserInfoAfter.vue'
    import FirstReturnVisit from '@/components/FirstReturnVisit/FirstReturnVisit.vue'
    import Config from '@/config/app.js'
    import {goCall, dataBuryingPoint} from '@/utils/JSBridge.js'
    import { bindUserPhone } from '@/api/nursingEvaluation.js'
    import ReceiveOrderDeatil from '@/utils/mixin/ReceivedOrder.js'


    export default {
        name: 'app',
        mixins: [ReceiveOrderDeatil],
        data: function () {
            return {
            }
        },
        methods: {
            callPhone() {
                bindUserPhone({orderId:this.orderId}).then(r=>{
                    goCall(r.dstVirtualNum);
                }).catch(e=>{console.log(e)});
                dataBuryingPoint('C000004', 'C000004-007');
            },
            callPolice() {
                let tel = Config.alarmCall;
                goCall(tel);
                setTimeout(() => {
                    dataBuryingPoint('F000017', 'F000017-001');
                }, 300);
            },
        },
        created() {
        },
        mounted() {

        },
        beforeDestroy: function () {

        },
        components: {Icon, Button, ServiceOptions, AfterInfo, UserInfoAfter, FirstReturnVisit}
    }
</script>
<style lang="scss">
    #app {
        background: rgba(255, 255, 255, 1);
        min-height: 100vh;

        .wrapper {
            padding-bottom: 60px;

            /*头部内容*/
            .top-content {
                background-color: #F84025;
                background-image: url("../../assets/img/city.png");
                background-size: cover;
                background-repeat: no-repeat;
                background-position: top center;
                overflow: hidden;
                padding-left: 30px;

                h2 {
                    color: rgba(255, 255, 255, 1);
                    margin-top: 23px;
                    margin-bottom: 23px;
                }

                .top_tip {
                    display: flex;
                    align-items: center;
                    font-size: 15px;
                    color: rgba(255, 255, 255, 1);

                    &-tip {
                        margin-left: 3px;
                    }
                }
            }
        }

        .interval {
            width: 100%;
            height: 5px;
            background: rgba(243, 245, 249, 1);
        }

        .cert-group {
            button {
                margin-right: 10px;
                margin-top: 10px;
            }
        }


        .u-bottom-btns {
            .btn-recommend {
                flex-grow: 0;
                width: 60px;
            }

            .btn-help {
                width: 60px;
            }

            .btn-success {
                flex: 1;
                overflow: hidden;
                color: #FFFFFF;
                background: #F84025;
            }

        }
    }

</style>
